module.exports = __webpack_public_path__ + "static/img/mobilebg.71bc230a.jpg";